export var DEFAULT_STORE = 'blzstore';